

const Defaults = {
  search: {
    locations: [],
    termsInclude: [],
    termsExclude: [],
    industryInclude: [],
    industryExclude: [],
    revenueLowerBound: null,
    revenueUpperBound: null,
    employeesLowerBound: null,
    employeesUpperBound: null,
    naturalLanguageQuery: "",
    OnlyNaturalLanguageQuery: false,
  }
}

export default Defaults